import React, { useState } from 'react';
import {
  Toast, Card, Button, Col, Row,
} from 'react-bootstrap';
import { LoadingAnimation } from '../../../common/components/Utilities';
import { EditButton } from '../../../common/components/Buttons';
import LegacyUserResource from '../../../common/resource/LegacyUserResource';

function UserHealth({ user, csrfToken }) {
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    _token: csrfToken,
    health_form_url: user.health_form_url,
    health_reasonable_adjustments: user.health_reasonable_adjustments,
  });
  const [formDataBefore, setFormDataBefore] = useState({ ...formData });
  const [toasts, setToasts] = useState([]);

  const changeFormData = (event) => {
    formData[event.target.name] = event.target.value;
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const toggleEdit = () => {
    setEditing(!editing);
    if (!editing) {
      setFormDataBefore({ ...formData });
    }
  };

  const handleCancelEdit = () => {
    setEditing(false);
    setFormData(formDataBefore);
  };

  const onCloseToast = (key) => {
    toasts[key].closed = 1;
    setToasts([...toasts]);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await LegacyUserResource.putHealthInfo(user.id, formData);
      if (response) {
        setFormDataBefore({ ...formData });
        toggleEdit();
      } else {
        toasts.push({ title: 'Unable to save', description: 'There was an unexpected response from the server while saving. Please try again.' });
      }
      setToasts(toasts);
    } catch (error) {
      toasts.push({ title: 'Unable to save', description: 'There was an unexpected response from the server while saving. Please try again.' });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingAnimation loading={loading} />
      <h2 className="mb-4">Health Information</h2>
      <Row>
        <Col md={9}>

          <Card className="mb-4" style={{ minHeight: '130px' }}>
            <Card.Header>Sharepoint Form</Card.Header>
            <Card.Body>

              {!editing

                      && <div><a href={formData.health_form_url} target="_blank" rel="noreferrer">{formData.health_form_url}</a></div>}
              {editing

                      && <input type="text" className="form-control" name="health_form_url" onChange={changeFormData} value={formData.health_form_url} />}

            </Card.Body>
          </Card>
          <Card className="mb-4" style={{ minHeight: '130px' }}>
            <Card.Header>Reasonable Adjustments</Card.Header>
            <Card.Body>

              {!editing

                && <div>{formData.health_reasonable_adjustments}</div>}
              {editing

                && <textarea type="text" className="form-control" style={{ height: '200px' }} rows="30" name="health_reasonable_adjustments" onChange={changeFormData} value={formData.health_reasonable_adjustments} />}

            </Card.Body>
          </Card>

        </Col>
        <Col md={3}>

          {!editing

        && <EditButton onClick={toggleEdit} icon="edit">Edit</EditButton>}

          {editing

          && (
          <>
            <EditButton onClick={handleSave} icon="edit" className="mr-2">Save</EditButton>
            <Button onClick={handleCancelEdit} type="button" variant="secondary" className="ml-2">Cancel</Button>
          </>
          )}

          <div className="mt-4">

            {toasts.map((toast, key) => {
              if ('closed' in toast && toast.closed === 1) {
                return null;
              }
              return (
                <div key={key}>
                  <Toast onClose={() => onCloseToast(key)} delay={3000} autohide position="top-center">
                    <Toast.Header>
                      <strong className="me-auto">{toast.title}</strong>
                      <small className="ml-2">Just Now</small>
                    </Toast.Header>
                    <Toast.Body>{toast.description}</Toast.Body>
                  </Toast>
                </div>
              );
            })}

          </div>
        </Col>
      </Row>
    </>
  );
}

export default UserHealth;
